import SearchIcon from "@mui/icons-material/Search";
import { Grid, MenuItem, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appIcons } from "../../../assets";
import GlobalButton from "../../../components/button";
import CustomContainer from "../../../components/container/CustomContainer";
import InputField from "../../../components/InputField";
import CustomSelect from "../../../components/select";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import { getAllCategories } from "../../../services/categoriesFn";
import ProductCartCard from "./../../../components/cards/ProductCartCard";

const UserCart = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const cartData = useSelector((state) => state.cartReducer.cartData);
  const userData = useSelector((state) => state.userReducer.user);

  useEffect(() => {
    fetchAllCategories();
  }, []);

  const fetchAllCategories = async () => {
    try {
      setIsLoading(true);
      const response = await getAllCategories();
      if (response.data.status === "success") {
        setAllCategories(response.data.data);
      }
    } catch (error) {
      showSnackbar(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const renderMenuBar = () => {
    return (
      <Stack
        p={2}
        gap={2}
        bgcolor={"primary.light"}
        direction={{ xs: "column", sm: "row" }}
      >
        <InputField
          styleProps={{ width: { xs: "100%", md: "30%" } }}
          InputStartIcon={<SearchIcon />}
        />
        <CustomSelect
          icon={<img src={appIcons.blackFilterIcon} width={16} />}
          formStyleProps={{ width: { xs: "100%", md: "20%" } }}
          placeholder={"Category"}
        >
          <MenuItem>helo</MenuItem>
        </CustomSelect>
      </Stack>
    );
  };

  return (
    <CustomContainer
      primaryHeading={t("myCart")}
      secondaryHeading={t("hitList")}
      // menuBarProps={renderMenuBar()}
      customIcom={
        <img
          src={appIcons.blackCartIcon}
          style={{
            width: 30,
            height: 30,
          }}
        />
      }
    >
      <Grid container spacing={2}>
        {cartData?.map((val, index) => {
          return (
            <Grid key={index} item xs={12} sm={6} md={4}>
              <ProductCartCard product={val} index={index} />
            </Grid>
          );
        })}
      </Grid>

      <Stack gap={2} alignItems={"center"}>
        {cartData?.length === 0 && (
          <Typography
            fontSize={20}
            textAlign={"center"}
            lineHeight={"normal"}
            mt={2}
          >
            {t('noItemsInCart')}
          </Typography>
        )}
        <GlobalButton
          btnText={"continueShopping"}
          handleClickBtn={() => navigate("/")}
          styleProps={{
            backgroundColor: "text.orangeRed",
            width: "auto",
            height: 50,
            fontSize: "1rem",
            textTransform: "uppercase",
          }}
        />
      </Stack>
    </CustomContainer>
  );
};

export default UserCart;
